/** TanStack Query hook for the caller's subscription, entitlements, and current-period usage. */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import type { SubscriptionResponse } from '@formency/shared';

export const subscriptionKeys = {
  all: ['f', 'subscription'] as const,
  me: () => [...subscriptionKeys.all, 'me'] as const,
};

export function useSubscription() {
  return useQuery<SubscriptionResponse>({
    queryKey: subscriptionKeys.me(),
    queryFn: () => api.get<SubscriptionResponse>('/me/subscription'),
    staleTime: 30_000,
  });
}
